import axios from 'axios'
import { API_URL } from '../../../../constants'
import { IPaymentAdapterListByMerchantRes, IPaymentAdapterListRes } from '../../../../types'

export const getPaymentAdapterList = (params?: {}) =>
  axios.get<IPaymentAdapterListRes>(`${API_URL}/api/internal/payment-adapter/list?enabled=true`)

export const getPaymentAdapterListByMerchant = (params?: {merchantToken: string, direction: string, paymentMethod: string}) =>
  axios.get<IPaymentAdapterListByMerchantRes>(`${API_URL}/api/internal/payment-adapter/list-by-merchant`, {
    params,
  })

export const getOperatorPaymentAdapterList = () =>
  axios.get<IPaymentAdapterListRes>(`${API_URL}/api/merchant/list`)
